import React, { Component } from 'react';
import { Form, Grid, Button } from 'semantic-ui-react';
import { connect } from 'react-redux';
import {
  DateForm,
  StatusList,
  Division,
  SearchInputBox,
  SikdaeGroup,
  SikdaePolicy
} from '../Commons';

class MealApproveForm extends Component {
  render() {
    const { sikdaeGroup, sikdaePolicy } = this.props;
    const {
      status,
      division,
      submitForm,
      sikdaeGroupSearch,
      sikdaeGroupVal,
      handleEntSubmit
    } = this.props.formFn;

    return (
      <Form className="top-form" onSubmit={submitForm}>
        <Grid>
          <Grid.Row className="form-row">
            <Grid.Column width={14}>
              <Form.Group>
                <DateForm openTodayBtn={true} />
                <SearchInputBox
                  handleSubmit={submitForm}
                  handleEntSubmit={handleEntSubmit}
                  placeHolder={'ID, 이름'}
                />
              </Form.Group>
            </Grid.Column>
            <Grid.Column width={2} className="form-right">
              <Button
                color="black"
                style={{ width: '100%' }}
                inverted
                content="조회"
              />
            </Grid.Column>
          </Grid.Row>

          <Grid.Row className="form-row">
            <Grid.Column width={16}>
              <Form.Group>
                <StatusList status={status} />
                <Division division={division} />
                <SikdaeGroup
                  sikdaeGroup={sikdaeGroup}
                  sikdaeGroupSearch={sikdaeGroupSearch}
                />
                <SikdaePolicy
                  sikdaeGroupVal={sikdaeGroupVal}
                  sikdaePolicy={sikdaePolicy}
                />
              </Form.Group>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Form>
    );
  }
}
MealApproveForm = connect(state => ({
  sikdaeGroup: state.commons.sikdaeGroup,
  sikdaePolicy: state.commons.sikdaePolicy
}))(MealApproveForm);

export default MealApproveForm;
